import { RotateCcwIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { useQuizContext } from "@/router/test/_hooks/QuizContext";

import { OptionButton } from "./quizView/OptionButton";

export function RecallView() {
  const {
    recallCurrentQuestion,
    recallCurrentIndex,
    recallCount,
    pendingRecallSelectedOptionIndex,
    selectRecallOption,
    skipRecall,
  } = useQuizContext();

  if (!recallCurrentQuestion || recallCount === 0) {
    return null;
  }

  return (
    <Card className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-primary-background pt-2 sm:mx-auto sm:h-fit sm:min-w-lg sm:max-w-4xl sm:rounded-2xl sm:pt-5 sm:shadow-lg">
      <CardHeader className="flex items-center justify-between px-5 sm:px-4 sm:pt-0">
        <div className="flex items-center gap-2 text-sm font-bold text-primary">
          <RotateCcwIcon className="size-4" />
          짧은 재회상
        </div>
        <span className="text-sm font-semibold text-muted-foreground">
          {recallCurrentIndex + 1} / {recallCount}
        </span>
      </CardHeader>

      <CardContent className="flex min-h-0 flex-1 flex-col items-center gap-6 px-5 sm:aspect-video sm:max-h-fit sm:px-4">
        <div className="flex min-h-40 w-full items-center justify-center rounded-xl bg-white">
          <span className="text-4xl font-extrabold tracking-wide text-tertiary">{recallCurrentQuestion.word}</span>
        </div>
        <p className="text-center text-sm font-medium text-muted-foreground">
          방금 틀린 단어의 뜻을 다시 떠올려 보세요.
        </p>
        <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
          {recallCurrentQuestion.options.map((option, index) => (
            <OptionButton
              key={`${recallCurrentQuestion.id}-${index}`}
              number={index + 1}
              meaning={option}
              isSelected={pendingRecallSelectedOptionIndex === index}
              isDisabled={pendingRecallSelectedOptionIndex !== null}
              onClick={() => selectRecallOption(index)}
            />
          ))}
        </div>
      </CardContent>

      <CardFooter className="flex items-center justify-center border-t-0 bg-transparent p-5 pb-6">
        <Button variant="ghost" size="lg" onClick={skipRecall} className="rounded-md px-8 text-muted-foreground">
          남은 재회상 건너뛰고 리포트 보기
        </Button>
      </CardFooter>
    </Card>
  );
}
